import { supabase } from '@/integrations/supabase/client';
import { Tables } from "@/integrations/supabase/types";

type Profile = Tables<'profiles'>;

export const deleteUser = async (userId: string) => {
  // Soft-delete: set is_employee to false
  const { error } = await supabase
    .from('profiles')
    .update({ is_employee: false })
    .eq('id', userId);
    if (error) throw error;
  return true;
};

export const getProfile = async (userId: string): Promise<Profile | null> => {
    const { data, error } = await supabase.from('profiles')
        .select('id, username, is_employee, is_admin, created_at, updated_at, is_approved')
        .eq('id', userId)
        .maybeSingle();
    if (error) throw error;
    return data;
};

export const getPendingUsers = async () => {
    const { data, error } = await supabase.rpc('get_pending_users');
    if (error) throw error;
    return data;
};

export const getAllUsers = async () => {
    const { data, error } = await supabase.rpc('get_all_users_for_admin');
    if (error) throw error;
    return data;
};

export const approveUser = async (userId: string) => {
    const { error } = await supabase.rpc('approve_user', { target_user_id: userId });
    if (error) throw error;
};

export const toggleUserAdminRole = async (userId: string, isAdmin: boolean) => {
    const { data, error } = await supabase.rpc('toggle_user_admin', {
        target_user_id: userId,
        is_admin: isAdmin,
    });
    if (error) {
        console.error("toggleUserAdminRole RPC error:", error);
        console.error("toggleUserAdminRole RPC data:", data);
        throw error;
    }
    return data;
}; 